module.exports = __webpack_public_path__ + "img/white-and-grey-bedspread-3264493.73507444.jpg";